import { Component, Prop, toNative, Vue } from '@natureos/vue-facing-decorator';

@Component({ name: 'Badge' })
class Badge extends Vue {
  @Prop({
    type: String,
    default: 'brand',
    validator: (value: string) =>
      ['brand', 'success', 'warning', 'danger', 'info', 'ghost'].includes(value),
  })
  public readonly variant!: string;

  @Prop({
    type: String,
    default: 'md',
    validator: (value: string) => ['sm', 'md', 'lg'].includes(value),
  })
  public readonly size!: string;

  public isVisible: boolean = true;

  public get badgeClasses(): string {
    const baseClasses =
      'inline-flex font-roboto items-center rounded font-medium transition-colors';

    const variantClasses: Record<string, string> = {
      brand: 'bg-brand-100 text-brand-800',
      success: 'bg-green-100 text-green-800',
      warning: 'bg-yellow-100 text-yellow-800',
      danger: 'bg-red-100 text-red-800',
      info: 'bg-cyan-100 text-cyan-800',
      ghost: 'bg-transparent text-gray-600 border border-gray-300',
    };

    const sizeClasses: Record<string, string> = {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-3 py-1 text-sm',
      lg: 'px-4 py-1.5 text-base',
    };

    return [
      baseClasses,
      variantClasses[this.variant],
      sizeClasses[this.size],
      this.isVisible ? '' : 'hidden',
    ].join(' ');
  }
}

export default toNative(Badge);
export { default as Badge } from './badge.component.vue';
